import $ from "jquery";
import initCustomerRegistration from "./customer-register"
import initCustomerDashboard from "./customer-dashboard"

export default (window) => {
    initCustomerRegistration(window);
    initCustomerDashboard(window);
}